import { wrapErrorHandler } from "../../utils/wrap_error_handler";
import http from "../../http/index";
import NotificationInterface from "./notification_interface";
import { Notification } from "../../../../domain/entities/notifications/notification";

class NotificationRepository implements NotificationInterface {
  async list(): Promise<Notification[]> {
    return wrapErrorHandler<Notification[]>(async () => {
      const response = await http.get("/api/decola/notifications");
      return response.data;
    });
  }

  async watch(notificationID: number): Promise<void> {
    return wrapErrorHandler<void>(async () => {
      return await http.post(
        `/api/decola/notification/${notificationID}/watch`
      );
    });
  }

  async delete(notificationID: number): Promise<void> {
    return wrapErrorHandler<void>(async () => {
      return await http.delete(
        `/api/decola/notification/${notificationID}/delete`
      );
    });
  }

  async get(notificationID: number): Promise<Notification> {
    return wrapErrorHandler<Notification>(async () => {
      const response = await http.get(
        `/api/decola/notification/${notificationID}`
      );
      return response.data;
    });
  }
}

export default new NotificationRepository() as NotificationInterface;
